module.exports = __webpack_public_path__ + "img/pic21.f38a2efa.png";